export default __webpack_public_path__ + "images/2c6cfbcd7fcd41ad56470acfa50f2041-latin_music.jpg";